import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { CadastralSectionService } from '../proxy/planning/controllers/cadastral-section.service';
import { DepartmentService } from '../proxy/planning/controllers/department.service';
FieldBuilder.setNamespace('Planning');

export const SUPPLYREGISTER_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('number', 'Entity.SupplyRegister.Number')
    .required()
    .build(),
  FieldBuilder.foreignKey('cadastralSectionId', 'Entity.CadastralSection', CadastralSectionService)
    .displayFromNested('cadastralSection.name')
    .sortBy('cadastralSection.name')
    .build(),
  FieldBuilder.foreignKey('departmentId', 'Entity.Department', DepartmentService)
    .displayFromNested('department.name')
    .sortBy('department.name')
    .build(),
];

export const SUPPLYREGISTER_CONFIG = {
  entityName: 'SupplyRegister',
  localizationKey: 'Planning::Entity.SupplyRegister',
  fields: SUPPLYREGISTER_FIELDS,
  permission: 'ControllingContract.SupplyRegistries',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
